interface BrandLinkProps {
    brandName: string;
}

export default function BrandLink({brandName}: BrandLinkProps) {
    const getBrandSite = (brandName: string) => {
        const brandSites: Record<string, string> = {
            'thorvik': 'https://www.thorvik.ru',
            'ombra': 'https://www.ombratools.ru',
            'carbon': 'https://www.carbontools.ru',
            'jonnesway': 'https://www.jonnesway.ru',
            'rotake': 'https://www.rotakepro.ru',
        };
        return brandSites[brandName.toLowerCase()] || 'https://www.pride.ru';
    }

    return (<a href={getBrandSite(brandName)} className="d-flex align-items-center">
        <span>О бренде</span>
        <svg width="10" height="20" viewBox="0 0 10 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M-3.01789e-07 1.63454L1.48725 -4.55891e-06L9.58796 8.90825C9.71854 9.05099 9.82217 9.22073 9.89288 9.4077C9.9636 9.59467 10 9.79518 10 9.99768C10 10.2002 9.9636 10.4007 9.89288 10.5877C9.82216 10.7746 9.71854 10.9444 9.58796 11.0871L1.48725 20L0.00140014 18.3655L7.60448 10L-3.01789e-07 1.63454Z"
                fill="#898A8C"/>
        </svg>
    </a>
    );
}